export default __webpack_public_path__ + "static/media/solidworks-home.541a1567.png";